/* eslint-disable react/no-unknown-property,jsx-a11y/iframe-has-title */

'use client'

import { useIsAppControl } from '@store/isApp'
import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'
import useIframeZoom from '@hooks/useIframeZoom'
import { theme } from '@ui/style'

/** 아티클(기사) 상단 텍스트 광고 */
const TextBottomAd = () => {
	const { iframeStyles } = useIframeZoom()
	const { isApp } = useIsAppControl()

	if (isApp) {
		return null
	}

	return (
		<Box
			width={{
				xs: '100%',
				md: pxToRem(388),
				lg: pxToRem(308),
				xl: pxToRem(476),
			}}
			sx={{
				'& .adtssp_mo': {
					display: { xs: 'block', md: 'none' },
					'&>div': {
						[theme.mediaQueries.under.origin]: {
							width: `${pxToRem(353)}!important`,
							height: `${pxToRem(95)}!important`,
							overflow: 'hidden',
							'&>iframe': {
								...iframeStyles,
								position: 'static!important',
							},
						},
					},
				},
				'& .adtssp_pc': {
					display: { xs: 'none', md: 'block' },
				},
				'& iframe': {
					display: 'block',
				},
			}}
		>
			{/* 상단 PC */}
			<Box
				display={{
					xs: 'none',
					lg: 'block',
				}}
				fontSize={0}
			>
				<iframe
					src="//adv.imadrep.co.kr/9674_04.html"
					width="100%"
					height="213"
					frameBorder="0"
					scrolling="no"
				/>
			</Box>
			{/* 상단 MO */}
			<Box
				display={{
					xs: 'block',
					lg: 'none',
				}}
				fontSize={0}
				sx={{
					[theme.mediaQueries.under.origin]: {
						width: pxToRem(353),
						height: pxToRem(240),
						overflow: 'hidden',
						'&>iframe': iframeStyles,
					},
				}}
			>
				<iframe
					src="//adv.imadrep.co.kr/9695_04.html"
					width="100%"
					height="240"
					frameBorder="0"
					scrolling="no"
				/>
			</Box>
			{/* 하단 PC */}
			<Box
				display={{
					xs: 'none',
					lg: 'block',
				}}
				sx={{
					[theme.mediaQueries.under.origin]: {
						height: pxToRem(123),
						overflow: 'hidden',
						'&>iframe': iframeStyles,
					},
				}}
			>
				<iframe
					width="100%"
					height="123"
					id="0HEe"
					src="//ad.reople.co.kr/cgi-bin/PelicanC.dll?impr?pageid=0HEe&out=iframe"
					allowTransparency
					marginWidth={0}
					marginHeight={0}
					frameBorder="0"
					scrolling="no"
					sandbox="allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-modals allow-top-navigation-by-user-activation allow-popups-to-escape-sandbox"
				/>
			</Box>
			{/* 하단 MO */}
			<Box
				display={{
					xs: 'block',
					lg: 'none',
				}}
				sx={{
					[theme.mediaQueries.under.origin]: {
						height: pxToRem(117),
						overflow: 'hidden',
						'&>iframe': iframeStyles,
					},
				}}
			>
				<iframe
					width="100%"
					height="117"
					src="//ad.reople.co.kr/cgi-bin/PelicanC.dll?impr?pageid=0HEc&out=iframe"
					allowTransparency
					marginWidth={0}
					marginHeight={0}
					frameBorder="0"
					scrolling="no"
					sandbox="allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-modals allow-top-navigation-by-user-activation allow-popups-to-escape-sandbox"
				/>
			</Box>
		</Box>
	)
}
export default TextBottomAd
